import {
  faBriefcase,
  faUserAstronaut
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonLink from 'components/shared/ButtonLink.styled';
import { Heading3 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/dist/client/router';
import Link from 'next/link';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { StyledActions, StyledCta } from './Cta.styled';

const Cta: React.FC = () => {
  const { t } = useI18n('web');
  const { locale } = useRouter();

  return (
    <StyledCta>
      <Heading3 editorial>{t('cta.title')}</Heading3>
      <p>{t('cta.desc')}</p>
      <StyledActions>
        <Link href={getAppUrl(APP_URLS.join, locale)} passHref>
          <ButtonLink variant="brandTalent" sizes="md">
            <FontAwesomeIcon icon={faUserAstronaut} />
            <span>{t('cta.actions.beManfredite')}</span>
          </ButtonLink>
        </Link>
        <ButtonLink
          href={getAppUrl(APP_URLS.companies, locale)}
          variant="brandCompany"
          sizes="md"
        >
          <FontAwesomeIcon icon={faBriefcase} />
          <span>{t('cta.actions.findManfredites')}</span>
        </ButtonLink>
      </StyledActions>
    </StyledCta>
  );
};

export default Cta;
